import { faImage, faRedo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Card, CardBody, Input, Label, Spinner } from "reactstrap";
import { getFile } from "../../utils/digitalOcean/digitalocean-upload-file";

const ImageCropper = ({ initialState, onChange }) => {
  const [showedLabel, setShowedLabel] = useState(false);
  const [loading, setLoading] = useState(false);

  console.log(initialState);

  const imageInterprete = (file) => {
    let image;

    if (typeof file === "string") {
      image = getFile(file);
    } else {
      image = URL.createObjectURL(file);
    }
    return image;
  };

  const handleLogoChange = (e) => {
    if (!e.target.files[0]) {
      console.log("No seleccionaste una foto");
      onChange(null, setLoading);
      return;
    }
    setLoading(true);
    onChange(e.target.files[0], setLoading);
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 1234);
  // }, []);

  return (
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          cursor: "pointer",
          position: "relative",
          marginTop: 15,
          marginBottom: 15,
        }}
      >
        <Input
          type="file"
          name="logo"
          id="logo"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleLogoChange}
        />
        {!initialState && (
          <Card
            tag={Label}
            htmlFor="logo"
            style={{
              borderRadius: "7px",
              border: "2px dashed #9900cc",
              cursor: "pointer",
            }}
          >
            <CardBody>
              <Label htmlFor="logo" style={{ margin: 0, cursor: "pointer" }}>
                {loading ? (
                  <Spinner
                    size={"sm"}
                    style={{ fontSize: "10px", marginBottom: "10px" }}
                  />
                ) : (
                  <FontAwesomeIcon
                    style={{ fontSize: "20px", marginBottom: "10px" }}
                    icon={faImage}
                  />
                )}
                <h6 className="alert-heading" style={{ fontWeight: "initial" }}>
                  Agrega un logo para este condominio
                </h6>
              </Label>
            </CardBody>
          </Card>
        )}
        {initialState && (
          <span
            style={{
              position: "relative",
              height: "200px",
              width: "200px",
              borderRadius: "100px",
              overflow: "hidden",
            }}
            onMouseLeave={() => {
              setShowedLabel(false);
            }}
            onMouseEnter={() => {
              setShowedLabel(true);
            }}
          >
            <img
              src={imageInterprete(initialState)}
              alt=""
              style={{
                background: "#00000011",
                minWidth: "200px",
                maxWidth: "200px",
                minHeight: "200px",
                maxHeight: "200px",
                borderRadius: "100px",
                aspectRatio: "1 / 1",
                filter: loading ? "blur(1px) saturate(0.5)" : "unset",
              }}
            />
            {Boolean(showedLabel || loading) && (
              <span
                style={{
                  left: 0,
                  width: "100%",
                  height: "200px",
                  cursor: "pointer",
                  position: "absolute",
                  borderRadius: "100px",
                  background: "#00000044",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {loading ? (
                  <Spinner style={{ alignItems: "center" }} />
                ) : (
                  <Label
                    htmlFor="logo"
                    className="btn btn-primary"
                    style={{
                      position: "absolute",
                      right: 0,
                      bottom: 0,
                      width: "100%",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faRedo}
                      style={{ marginRight: "10px" }}
                    />
                    Cambiar logo
                  </Label>
                )}
              </span>
            )}
          </span>
        )}
      </div>
    </div>
  );
};

export default ImageCropper;
